{
  "party": {
    "maxMembers": 8,
    "maxLevelGap": 40,
    "xpBonusPerMember": 0.05,
    "goldBonusPerMember": 0.05,
    "dropBonusPerMember": 0.05,
    "xpShareRangeM": 60,
    "inviteTtlMs": 60000,
    "offlineGraceMs": 90000
  },
  "clan": {
    "maxMembers": 30,
    "maxOfficers": 4,
    "createMinLevel": 15,
    "createCostGold": 10000,
    "nameMin": 3,
    "nameMax": 16,
    "inviteTtlMs": 60000,
    "grades": [
      {
        "grade": 5,
        "minNp": 0
      },
      {
        "grade": 4,
        "minNp": 3000
      },
      {
        "grade": 3,
        "minNp": 10000
      },
      {
        "grade": 2,
        "minNp": 30000
      },
      {
        "grade": 1,
        "minNp": 80000
      }
    ]
  },
  "maxCharactersOnline": 1,
  "maxCharactersPerDevice": 2,
  "maxCharactersPerIp": 4,
  "friends": {
    "max": 50
  }
}
